<template>
  <div class="pdf-preview">
    <el-container class="page-frame">
      <el-header class="site-header-region">
        <Header />
      </el-header>
      <el-container class="container">
        <el-aside :width="meunWidth + 'px'">
          <Menu ref="menu" @toggleMenu="toggleMenu" />
        </el-aside>
        <el-main>
          <PdfView :isShowMenu="meunWidth > 72" />
        </el-main>
      </el-container>
    </el-container>
    <el-footer class="site-footer-region">
      <Footer />
    </el-footer>
  </div>
</template>
<script>
import Header from "./modules/Header";
import Menu from "./modules/Menu";
import Footer from "./modules/Footer";
import PdfView from "./modules/PdfView";
export default {
  components: {
    Header,
    Menu,
    PdfView,
    Footer,
  },
  // 变量声明
  data() {
    return {
      meunWidth: 72,
    };
  },
  watch: {},
  computed: {},
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  // 方法
  methods: {
    toggleMenu(meunWidth) {
      this.meunWidth = meunWidth;
    },
  },
};
</script>
<style lang="less" scoped>
.pdf-preview {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #1a1a2e;
  background: #f5f8fa;
  font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;

  .page-frame {
    min-height: 0;
    flex: 1;
  }

  .container {
    min-width: 0;
    min-height: 0;
    flex: 1;
    width: 100%;
    background: #f3f7f9;

    /deep/.el-aside {
      overflow: hidden;
      background: #ffffff;
      border-right: 1px solid #e3eceb;
      transition: width 0.18s ease;
    }

    /deep/.el-main {
      min-width: 0;
      padding: 18px;
      overflow: hidden;
    }
  }

  .site-header-region {
    flex: 0 0 64px;
    padding: 0;
    height: 64px !important;
    z-index: 99;
  }

  .site-footer-region {
    flex: 0 0 64px;
    padding: 0;
    height: 64px !important;
  }
}

@media (max-width: 900px) {
  .pdf-preview {
    .site-footer-region {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .pdf-preview {
    height: 100dvh;
    min-height: 100dvh;

    .page-frame {
      padding-bottom: calc(58px + env(safe-area-inset-bottom));
      box-sizing: border-box;
    }

    .site-header-region {
      flex-basis: 56px;
      height: 56px !important;
    }

    .container {
      /deep/.el-aside {
        display: none;
      }

      /deep/.el-main {
        width: 100%;
        padding: 8px;
      }
    }
  }
}
</style>
